module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-detail"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.$t('nav.remotePay')))]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.$t('nav.orderManage')))]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.$t('orderManage.detail')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel down"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('div', {
    staticClass: "details"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v(_vm._s(_vm.$t('orderManage.detail')))]), _vm._v(" "), (_vm.deliveryStatus === 1 && _vm.tranStatus === 2 && _vm.delivery_info.delivery_type === _vm.$t('remote.form.logisticsMode.option2')) ? _c('div', {
    staticClass: "panel-header-btn btn1",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.show = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('orderManage.delevery')))]) : _vm._e(), _vm._v(" "), (_vm.tranStatus === 1) ? _c('div', {
    staticClass: "panel-header-btn btn2",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openEdit
    }
  }, [_vm._v(_vm._s(_vm.$t('orderEdit.edit')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "mcht-information"
  }, [_c('div', {
    staticClass: "mcht"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('orderDetail.mchtOrderId')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.mcntOrderId))])]), _vm._v(" "), _c('div', {
    staticClass: "mcht"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('orderDetail.payOrderId')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.payOrderId))])]), _vm._v(" "), _c('div', {
    staticClass: "mcht"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('orderDetail.linkId')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.linkId))])]), _vm._v(" "), _c('div', {
    staticClass: "mcht"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('orderDetail.transactionStatus')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.tranStatusLang))])]), _vm._v(" "), _c('div', {
    staticClass: "mcht"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('orderDetail.paymentlink')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.payLink))])]), _vm._v(" "), _c('div', {
    staticClass: "mcht"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('orderDetail.createTime')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.stime))])]), _vm._v(" "), _c('div', {
    staticClass: "mcht expected-date"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('orderDetail.expectedDeliveryTime')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.delivery_info.delivery_time))])])]), _vm._v(" "), _c('div', {
    staticClass: "product-information"
  }, [_c('p', {
    staticClass: "product-title"
  }, [_vm._v(_vm._s(_vm.$t('orderDetail.productTitle')))]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.goods_info
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Goods Name",
      "prop": "goods_name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Quantity",
      "prop": "quantity"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Currency",
      "prop": "currency"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(_vm.currencyList[scope.row.currency]) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Unit Price",
      "prop": "unit_price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Total Price",
      "prop": "total_currency"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(_vm.currencyList[scope.row.currency]) + " " + _vm._s(scope.row.total_currency) + "\n            ")]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "total-price product"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('orderDetail.totalAmount')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.totalNum))])]), _vm._v(" "), _c('div', {
    staticClass: "delivery-status product"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('orderDetail.deliveryStatus')))]), _vm._v(" "), (_vm.delivery_info.delivery_type === _vm.$t('remote.form.logisticsMode.option2')) ? _c('p', [_vm._v(_vm._s(_vm.deliveryStatusList[_vm.deliveryStatus]))]) : _c('p', [_vm._v(_vm._s(_vm.$t('orderManage.filter.noDelivery')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "buyer-information"
  }, [_c('p', {
    staticClass: "buyer-title"
  }, [_vm._v(_vm._s(_vm.$t('orderDetail.buyerTitle')))]), _vm._v(" "), _c('div', {
    staticClass: "buyer"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('orderDetail.customerName')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.customer_info.name))])]), _vm._v(" "), _c('div', {
    staticClass: "buyer"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('orderDetail.customerPhone')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.customer_info.mobile))])]), _vm._v(" "), _c('div', {
    staticClass: "buyer"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('orderDetail.customerEmail')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.customer_info.email))])]), _vm._v(" "), _c('div', {
    staticClass: "buyer"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('orderDetail.customerAdress')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.customer_info.address))])])]), _vm._v(" "), _c('div', {
    staticClass: "express-information"
  }, [_c('p', {
    staticClass: "express-title"
  }, [_vm._v(_vm._s(_vm.$t('orderDetail.expressTitle')))]), _vm._v(" "), _c('div', {
    staticClass: "express"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('orderDetail.logisticsMode')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.delivery_info.delivery_type))])]), _vm._v(" "), _c('div', {
    staticClass: "express"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('orderDetail.expectedDeliveryTime')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.delivery_info.delivery_time))])]), _vm._v(" "), (_vm.deliveryStatus === 2) ? _c('div', {
    staticClass: "express"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('orderDetail.expressCompany')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.delivery_info.express_name))])]) : _vm._e(), _vm._v(" "), (_vm.deliveryStatus === 2) ? _c('div', {
    staticClass: "express"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('orderDetail.expressNumber')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.delivery_info.express_no))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "remaks"
  }, [_c('p', {
    staticClass: "remaks-title"
  }, [_vm._v(_vm._s(_vm.$t('orderDetail.description')))]), _vm._v(" "), _c('p', {
    staticClass: "remark-content"
  }, [_vm._v(_vm._s(_vm.desc))])])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "fe_dialog",
    attrs: {
      "visible": _vm.show,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.show = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialogTitle",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('orderManage.confirmDelivery')))])]), _vm._v(" "), _c('div', {
    staticClass: "dialogContent"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('orderManage.deliveryMsg')))]), _vm._v(" "), _c('el-form', {
    ref: "expressForm",
    attrs: {
      "model": _vm.expressForm,
      "label-width": "154px",
      "label-position": "left",
      "rules": _vm.expressFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('orderDetail.expressCompany'),
      "prop": "express_name"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50
    },
    model: {
      value: (_vm.expressForm.express_name),
      callback: function($$v) {
        _vm.$set(_vm.expressForm, "express_name", $$v)
      },
      expression: "expressForm.express_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('orderDetail.expressNumber'),
      "prop": "express_no"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50
    },
    model: {
      value: (_vm.expressForm.express_no),
      callback: function($$v) {
        _vm.$set(_vm.expressForm, "express_no", $$v)
      },
      expression: "expressForm.express_no"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelDelivery
    }
  }, [_vm._v(_vm._s(_vm.$t('orderManage.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.deliveryBtnStatus
    },
    on: {
      "click": _vm.delivery
    }
  }, [_vm._v(_vm._s(_vm.$t('orderManage.confirm')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "edit-information",
    attrs: {
      "visible": _vm.dialogVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialogTitle",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('orderEdit.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "dialogContent"
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-position": "left",
      "label-width": "174px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-table', {
    staticClass: "tableDatas",
    attrs: {
      "data": _vm.editForm.goods_info
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('remote.form.productName'),
      "prop": "goods_name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "disabled": ""
          },
          model: {
            value: (scope.row.goods_name),
            callback: function($$v) {
              _vm.$set(scope.row, "goods_name", $$v)
            },
            expression: "scope.row.goods_name"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('remote.form.quantity'),
      "prop": "quantity"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "disabled": ""
          },
          model: {
            value: (scope.row.quantity),
            callback: function($$v) {
              _vm.$set(scope.row, "quantity", $$v)
            },
            expression: "scope.row.quantity"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('remote.form.currency'),
      "prop": "currency"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "disabled": ""
          },
          model: {
            value: (scope.row.currency),
            callback: function($$v) {
              _vm.$set(scope.row, "currency", $$v)
            },
            expression: "scope.row.currency"
          }
        }, _vm._l((_vm.currentList), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.name,
              "value": item.value
            }
          }, [_vm._v(">\n                ")])
        }), 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('remote.form.price'),
      "prop": "unit_price"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "disabled": ""
          },
          model: {
            value: (scope.row.unit_price),
            callback: function($$v) {
              _vm.$set(scope.row, "unit_price", $$v)
            },
            expression: "scope.row.unit_price"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('remote.form.totalAmount'),
      "prop": "total_currency"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "disabled": ""
          },
          model: {
            value: (scope.row.total_currency),
            callback: function($$v) {
              _vm.$set(scope.row, "total_currency", $$v)
            },
            expression: "scope.row.total_currency"
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "close-icon",
    attrs: {
      "label": _vm.$t('remote.form.totalAmount')
    }
  }, [_c('el-select', {
    staticClass: "total-amount",
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm.totalCurrency),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "totalCurrency", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editForm.totalCurrency"
    }
  }, _vm._l((_vm.currentList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "sing-validte",
    attrs: {
      "prop": "totalAmount"
    }
  }, [_c('el-input', {
    staticClass: "inputtotal-amount",
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm.totalAmount),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "totalAmount", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editForm.totalAmount"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fe_payment-date",
    attrs: {
      "label": _vm.$t('remote.form.paymentDeadline')
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "clearable": false,
      "disabled": ""
    },
    model: {
      value: (_vm.editForm.paymentDeadline),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "paymentDeadline", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editForm.paymentDeadline"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "buyer-title-edit"
  }, [_vm._v(_vm._s(_vm.$t('orderEdit.buyerTitle')))]), _vm._v(" "), _c('el-form-item', {
    staticClass: "buyer-infomation-details",
    attrs: {
      "label": _vm.$t('orderDetail.customerName'),
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "inputtotal-amount",
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "buyer-infomation-details",
    attrs: {
      "label": _vm.$t('orderDetail.customerPhone'),
      "prop": "mobile"
    }
  }, [_c('el-input', {
    staticClass: "inputtotal-amount",
    model: {
      value: (_vm.editForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "mobile", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editForm.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "buyer-infomation-details",
    attrs: {
      "label": _vm.$t('orderDetail.customerEmail'),
      "prop": "email"
    }
  }, [_c('el-input', {
    staticClass: "inputtotal-amount",
    model: {
      value: (_vm.editForm.email),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "email", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "buyer-infomation-details address",
    attrs: {
      "label": _vm.$t('orderDetail.customerAdress'),
      "prop": "address"
    }
  }, [_c('el-input', {
    staticClass: "inputtotal-amount",
    model: {
      value: (_vm.editForm.address),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "address", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editForm.address"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "buyer-title-edit"
  }, [_vm._v(_vm._s(_vm.$t('orderEdit.expressTitle')))]), _vm._v(" "), _c('el-form-item', {
    staticClass: "buyer-infomation-details",
    attrs: {
      "label": _vm.$t('orderDetail.logisticsMode'),
      "prop": "delivery_type"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.editForm.delivery_type === _vm.$t('remote.form.logisticsMode.option4')
    },
    on: {
      "change": _vm.changeDate
    },
    model: {
      value: (_vm.editForm.delivery_type),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "delivery_type", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editForm.delivery_type"
    }
  }, _vm._l((_vm.logisticsModeList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "express-date",
    attrs: {
      "label": _vm.$t('remote.form.date')
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "clearable": false,
      "disabled": "",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.editForm.delivery_time),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "delivery_time", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editForm.delivery_time"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "buyer-title-edit"
  }, [_vm._v(_vm._s(_vm.$t('orderEdit.description')))]), _vm._v(" "), _c('el-form-item', {
    staticClass: "count-number",
    attrs: {
      "label": _vm.$t('orderDetail.description'),
      "prop": "desc"
    }
  }, [_c('el-input', {
    attrs: {
      "rows": 5,
      "type": "textarea",
      "maxlength": 500,
      "placeholder": _vm.$t('remote.form.writeDescription')
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.getCount($event)
      }
    },
    model: {
      value: (_vm.editForm.desc),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "desc", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editForm.desc"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.count) + "/500")])], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('orderManage.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.btnStatus
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('orderManage.confirm')))])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-686454a8"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/orderDetail/orderDetail.vue
// module id = 922
// module chunks = 0